/**
 * PluginButtons Component
 * Plugin Browser and Plugin Marketplace buttons
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Plug, Store } from 'lucide-react';

export const PluginBrowserButton = ({ setShowPluginBrowser }) => (
  <Button
    variant="ghost"
    size="sm"
    onClick={() => setShowPluginBrowser(true)}
    className="relative p-2 text-zinc-400 hover:text-white hover:bg-indigo-500/20"
    data-testid="plugin-browser-btn"
    title="Plugin Browser"
  >
    <Plug className="w-5 h-5" />
  </Button>
);

export const PluginMarketplaceButton = ({ setShowPluginMarketplace }) => (
  <Button
    variant="ghost"
    size="sm"
    onClick={() => setShowPluginMarketplace(true)}
    className="relative p-2 text-zinc-400 hover:text-white hover:bg-violet-500/20"
    data-testid="plugin-marketplace-btn"
    title="Plugin Marketplace"
  >
    <Store className="w-5 h-5" />
  </Button>
);

export default { PluginBrowserButton, PluginMarketplaceButton };
